<template>
  <div id="previewClass1" :style="previewClass1Style">
    <div id="Scroller">
      <TopMarquee :classtype="1" :issue="2"/>
      <div  id="ArticleCotainer">
        <div class="Article"
             v-for="(a,key) in allArticles" @click="viewArticle(a+1,2,$route.params.class)" :key="key">
          <div class="ArticleImg">
            <img :src="require('../assets/2/'+(a+1)+'/cover.jpg')">
          </div>
          <div class="ArticleTitle">
            {{article(a).shortbrief}}
          </div>
        </div>
      </div>
      <div id="endimg">
        <img src="../assets/end.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import articlesStore_2 from "../store/articlesStore_2"
import pageStackStore from "../store/pageStackStore"
import TopMarquee from "./MarqueePreview";
import store from "../store";

export default {
  name: "class2",
  components:{
    TopMarquee
  },
  data(){
    return {
      allArticles:[
      ],
      scrollerClass2:0
    }
  },
  mounted:function () {
    this.getArticles();
    var scrollerConfig = {
      '//Description' : 'Default scroller with no configuration',
      touchSpeed:1
    };
    window.scrollerClass2 = new Scroller('#previewClass1', scrollerConfig);
  },
  methods:{
    article(id){
      return articlesStore_2.state.articles[id];
    },
    getArticles:function () {
      let list=articlesStore_2.state['class1'].list
      this.allArticles=list
    },
    viewArticle:function(id,issue,thisclass){
      pageStackStore.commit('pushPageStack', this.$route.path)
      this.$router.replace({ name: 'Article',
        params: { id,issue,class:thisclass}})
    },
  },
  computed:{
    previewClass1Style(){
      return {
        height:(store.state.WindowSize.WindowHeightRem-0.9-1.31-1.11-1.31)+'rem'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

#previewClass1{
  .fullWidhth();

  height: 100%;

  #Scroller{
    .fullWidhth();

    background: white;

    #ArticleCotainer{
      .fullWidhth();

      .Article{
        background: #ffffff;
        overflow: hidden;

        width:10.35rem;
        height:5.46rem;
        margin-left: .45rem;
        margin-top:.45rem;
        border-radius:.45rem;
        box-shadow: 0px 0px .15rem .01rem #cccccc;

        .ArticleImg{
          .fullWidhth();

          overflow: hidden;
          height: 3.67rem;

          img{
            width: 100%
          }
        }

        .ArticleTitle{
          display:flex;
          align-items:center;
          padding-left: .75rem;
          padding-right: .75rem;
          //padding-right: 2.50rem;
          width:10.35rem;
          height:1.79rem;
          font-size:.32rem;
          line-height:.42rem;
        }
      }
    }


    #endimg{
      width: 2.58rem;
      margin-left: 4.335rem;
      margin-top: .6rem;
      margin-bottom: .9rem;

      img{
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/previewClass1.vue